import api from './api';
import { ApiResponse } from '../types';

export interface YearlyQuestionnaireStats {
  year: number;
  total: number;
  completed: number;
  inProgress: number;
  pending: number;
}

export interface SchoolParticipationStats {
  total: number;
  participated: number;
  notParticipated: number;
}

export interface DashboardStatsResponse {
  totalSchools: number;
  totalQuestionnaires: number;
  totalPublished: number;
  /** 今日新增答卷数 — completed_at 落今天的 COMPLETED 答卷 */
  todayCompletedAnswers: number;
  yearlyStats: YearlyQuestionnaireStats[];
  schoolParticipation: SchoolParticipationStats;
}

export const dashboardService = {
  getDashboardStats: async (orgId?: number): Promise<DashboardStatsResponse> => {
    const params = orgId != null ? { orgId } : {};
    const response = await api.get<ApiResponse<DashboardStatsResponse>>('/admin/dashboard/stats', { params });
    return response.data.data;
  },
};
